import React, { forwardRef, useState } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

// Password input with show/hide toggle. Mirrors the styling of <Input> exactly,
// so it slots into existing forms without layout shifts.
const PasswordInput = forwardRef(function PasswordInput(
  { className = "", testid, toggleTestid, ...props },
  ref,
) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input
        ref={ref}
        type={show ? "text" : "password"}
        className={`pr-10 ${className}`}
        data-testid={testid}
        {...props}
      />
      <button
        type="button"
        onClick={() => setShow((v) => !v)}
        tabIndex={-1}
        aria-label={show ? "Nascondi password" : "Mostra password"}
        className="absolute inset-y-0 right-0 px-3 flex items-center text-neutral-400 hover:text-primary transition-colors"
        data-testid={toggleTestid}
      >
        {show ? (
          <EyeOff className="w-4 h-4 transition-transform duration-150" strokeWidth={1.5} />
        ) : (
          <Eye className="w-4 h-4 transition-transform duration-150" strokeWidth={1.5} />
        )}
      </button>
    </div>
  );
});

export default PasswordInput;
